import { loadCSS, loadJS } from 'markmap-common';
import { Transformer } from 'markmap-lib';

export const transformer = new Transformer();

// 添加安全的转换函数
export const safeTransform = (text) => {
  try {
    if (!text || typeof text !== 'string') {
      return { root: null };
    }
    return transformer.transform(text);
  } catch (error) {
    console.error('Markmap transform error:', error);
    // 返回一个简单的根节点，避免崩溃
    return {
      root: {
        d: 'root',
        v: '转换失败',
        c: []
      }
    };
  }
};